// src/lib/uploadHelpers.js

export const BLOOMBERG_NA_REGEX = /^#n\/?a\b/i;

export const toISO = (s) => {
  if (!s) return null;
  const t = String(s).trim();
  if (!t) return null;

  const dateOnly = t.split(/[ T]/)[0];

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return dateOnly;

  const mdy = dateOnly.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (mdy) {
    const [, m, d, y] = mdy;
    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }

  return dateOnly;
};

export function parseNumeric(v) {
  if (v === "" || v == null) return NaN;

  let t = String(v).replace(/,/g, "").replace(/\u00A0/g, "").trim();
  if (t === "") return NaN;
  if (t === "-") return 0;
  if (/^\(.*\)$/.test(t)) t = "-" + t.slice(1, -1);

  return parseFloat(t);
}

export const toNullableFloat = (v) => {
  if (v === "" || v == null) return null;
  const num = parseNumeric(v);
  return Number.isNaN(num) ? null : num;
};

export const toZeroDefaultFloat = (v) => {
  if (v === "" || v == null) return 0;
  const num = parseNumeric(v);
  return Number.isNaN(num) ? null : num;
};

export const cleanText = (v) => {
  if (v === "" || v == null) return null;
  const t = String(v).trim();
  return t || null;
};

export const cleanVendorText = (v) => {
  if (v === "" || v == null) return null;
  const t = String(v).trim();
  if (!t) return null;
  if (BLOOMBERG_NA_REGEX.test(t)) return null;
  return t;
};

export const parseBooleanYN = (v) => {
  const t = String(v ?? "").trim().toUpperCase();
  if (t === "Y") return true;
  if (t === "N") return false;
  return null;
};

export const parseBooleanFalseOnUnknown = (v) => {
  const t = String(v ?? "").trim().toUpperCase();

  if (["Y", "YES", "TRUE", "T", "1", "TAXABLE"].includes(t)) return true;
  if (["N", "NO", "FALSE", "F", "0", "TAX-EXEMPT"].includes(t)) return false;

  return false;
};

export const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, (i + 1) * size)
  );